/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output, Type } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { IScrBaseResponse } from "../../../services";


export interface DialogEventDataWithId {
  id?: number;
};

export interface DialogEvent<T = object> {
  name: string;
  isCompleted: boolean;

  /**
   * Response message.
   */
  message?: string;

  /**
   * Response code for message
   */
  code?: string;


  error?: HttpErrorResponse | IScrBaseResponse;

  /**
   * Optional response data.
   */
  data?: T;
}

type DialogComponent = Type<any>;

@Component({
  selector: 'app-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss']
})
export class DynamicDialogComponent {

  activeComponent!: DialogComponent | null;
  activeComponentInputs: Record<string, unknown> | undefined = {};

  @Output() whenComplete = new EventEmitter<DialogEvent>();

  public show(component: DialogComponent, inputs: object) {
    this.activeComponent = component;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.activeComponentInputs = Object.assign({}, inputs, {
      callback: (e: DialogEvent) => {
        this.activeComponent = null;
        this.activeComponentInputs = undefined;
        self.whenComplete.emit(e);
      }
    });

  }


}

